<template>
  <div class="columns is-desktop">
    <div class="column">
      <config-data-marts-data-marts
        v-if="listDataMarts"
        @addDataMart="showAddDataMart()"
        @openDetails="showDataMartDetails($event)"
      />
      <config-data-marts-data-mart-details
        v-if="dataMartDetails"
        :datamartObject ="datamart"
        @resynchDatamartDetails="showDataMartSynchronizationDetails($event)"
        @dataMartList="showDataMartList()"
        @openDetails="showDataMartDetails()"
      />
      <config-data-marts-resynch-data-mart
        v-if="resynchDatamart"
        :datamartObject ="datamart"
        @dataMartList="showDataMartList()"
        @openDetails="showDataMartDetails()"
        @syncConfirmation="showDataMartSyncConfirmation()"
      />
      <config-data-marts-resynch-confirmation
          v-if="syncConfirmation"
          @dataMartList="showDataMartList()"
      />
      <config-data-marts-add-data-mart
        v-if="addDataMart"
         @dataMartList="showDataMartList()"
      />
    </div>
    <div class="column">
      <quick-tips-data-marts/>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEdit,
} from '@fortawesome/pro-solid-svg-icons';
import ConfigDataMartsAddDataMart from '@/components/ConfigDataMartsAddDataMart.vue';
import ConfigDataMartsDataMarts from '@/components/ConfigDataMartsDataMarts.vue';
import ConfigDataMartsDataMartDetails from '@/components/ConfigDataMartsDataMartDetails.vue';
import ConfigDataMartsResynchDataMart from '@/components/ConfigDataMartsResynchDataMart.vue';
import ConfigDataMartsResynchConfirmation from '@/components/ConfigDataMartsResynchConfirmation.vue';
import QuickTipsDataMarts from '@/components/QuickTipsDataMarts.vue';

library.add(
  faEdit,
);
export default {
  components: {
    ConfigDataMartsAddDataMart,
    ConfigDataMartsDataMarts,
    ConfigDataMartsDataMartDetails,
    ConfigDataMartsResynchDataMart,
    ConfigDataMartsResynchConfirmation,
    QuickTipsDataMarts,
  },
  data() {
    return {
      addDataMart: false,
      datamart: null,
      dataMartDetails: false,
      listDataMarts: true,
      resynchDatamart: false,
      syncConfirmation: false,
    };
  },
  methods: {
    showAddDataMart() {
      this.addDataMart = !this.addDataMart;
      this.listDataMarts = !this.listDataMarts;
    },
    showDataMartDetails(datamart) {
      this.datamart = datamart;
      this.dataMartDetails = !this.dataMartDetails;
      this.listDataMarts = !this.listDataMarts;
    },
     showDataMartSynchronizationDetails(datamart) {
      this.datamartObject = datamart;
      this.listDataMarts = false;
      this.dataMartDetails = false;
      this.resynchDatamart = true;
    },
    showDataMartSyncConfirmation() {
      this.listDataMarts = false;
      this.resynchDatamart = false;
      this.syncConfirmation = true;
    },
    showDataMartList() {
      this.addDataMart = false;
      this.dataMartDetails = false;
      this.listDataMarts = true;
      this.resynchDatamart = false;
      this.syncConfirmation = false;
    },
  },
};
</script>

<style lang="sass" scoped>
  .column
    height: 100%
</style>
